var initSticky = function initSticky() {
  var stickyBar = document.getElementById("sticky-quote-bar");
  if (!stickyBar) return;
  var heroSection = document.querySelector(".hero-banner");
  var ctaSection = document.querySelector(".cta-section");
  if (!heroSection) return;

  // variable to track visibility states
  var heroInView = true; // The hero is initially visible
  var ctaInView = false;
  var updateStickyBar = function updateStickyBar() {
    // Show the sticky bar only if:
    // 1. The hero is NOT in view AND
    // 2. The CTA is NOT in view (or doesn't exist)
    var shouldShow = !heroInView && !ctaInView;
    if (shouldShow) {
      stickyBar.classList.add("visible");
    } else {
      stickyBar.classList.remove("visible");
    }
  };
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.target === heroSection) {
        heroInView = entry.isIntersecting;
      }
      if (entry.target === ctaSection) {
        ctaInView = entry.isIntersecting;
      }

      // Update the sticky bar visibility based on the new states
      updateStickyBar();
    });
  }, {
    threshold: 0.1
  });
  observer.observe(heroSection);
  if (ctaSection) {
    observer.observe(ctaSection);
  }

  // Initial state - ensure the sticky bar is hidden on load
  stickyBar.classList.remove("visible");
};
export { initSticky };